import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './tablas.module.css';
import { MyIcons } from '../../components/icons/my-icons';
import { useModal } from '../../contexts/ModalContext';

const TablasPage = () => {
  const navigate = useNavigate();
  const { openModal } = useModal();
  const userRole = localStorage.getItem("userRole") || "ROLE_USER";

  const handleTablaClick = (modalName) => {
    openModal(modalName);
  };

  // Configuración de las tablas
  const tablasItems = [
    {
      id: 'contactos',
      title: 'Contactos',
      description: 'Gestión de contactos y clientes',
      icon: 'user',
      modalName: 'ContactsModal'
    },
    {
      id: 'operarios',
      title: 'Operarios',
      description: 'Gestión de operarios y técnicos',
      icon: 'user',
      modalName: 'OperatorsModal'
    },
    {
      id: 'companias',
      title: 'Compañías',
      description: 'Gestión de compañías',
      icon: 'folder',
      modalName: 'CompanyModal'
    },
    {
      id: 'presupuestos',
      title: 'Presupuestos Predeterminados',
      description: 'Plantillas de presupuestos',
      icon: 'file',
      modalName: 'PresetBudgetModal'
    },
    {
      id: 'notas',
      title: 'Notas de Presupuesto',
      description: 'Notas y comentarios predefinidos',
      icon: 'file',
      modalName: 'BudgetNotesModal'
    },
    {
      id: 'comerciales',
      title: 'Comerciales',
      description: 'Gestión de comerciales',
      icon: 'user',
      modalName: 'CommercialsModal'
    },
    {
      id: 'gremios',
      title: 'Gremios',
      description: 'Clasificación por gremios',
      icon: 'settings',
      modalName: 'GuildsModal'
    },
    {
      id: 'marcadores',
      title: 'Marcadores de Corte Gmail',
      description: 'Configuración de marcadores de email',
      icon: 'settings',
      modalName: 'GmailCutMarkersModal'
    },
    {
      id: 'estados',
      title: 'Estados',
      description: 'Estados de expedientes y trabajos',
      icon: 'settings',
      modalName: 'StatesModal'
    },
    {
      id: 'tipos',
      title: 'Tipos de Trabajo',
      description: 'Categorías de trabajos',
      icon: 'settings',
      modalName: 'JobTypeModal'
    },
    {
      id: 'localidades',
      title: 'Localidades',
      description: 'Gestión de ubicaciones',
      icon: 'folder',
      modalName: 'LocalityModal'
    }
  ];

  const renderTablaCard = (tabla) => {
    return (
      <div
        key={tabla.id}
        className={styles.tablaCard}
        onClick={() => handleTablaClick(tabla.modalName)}
      >
        <div className={styles.tablaContent}>
          <h3 className={styles.tablaTitle}>{tabla.title}</h3>
          <p className={styles.tablaDescription}>{tabla.description}</p>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Tablas del Sistema</h1>
        <p className={styles.subtitle}>
          Gestiona los datos maestros y configuraciones del sistema
        </p>
      </div>

      <div className={styles.content}>
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Datos Maestros</h2>
          </div>
          <p className={styles.sectionDescription}>
            Configura y gestiona toda la información base del sistema
          </p>
          <div className={styles.tablaGrid}>
            {tablasItems.map(renderTablaCard)}
          </div>
        </section>
      </div>
    </div>
  );
};

export default TablasPage;
